import { render, staticRenderFns } from "./InsurancePayment.vue?vue&type=template&id=fa05cfe4&"
import script from "./InsurancePayment.vue?vue&type=script&lang=js&"
export * from "./InsurancePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports